module.exports = __webpack_public_path__ + "img/icon-wx.33da752d.png";